var $            = require('./jCube');
var Const        = require('../defines');
var Lang         = require('./uk');
var ErrorHandler = require('./exceptions');

require('./ui');

var App = /** @class */ function () {

    var _this = this;

    window.addEventListener('error', function(e) {

        var _err = {
            message: e.message,
            name: e.type
        };

        if(e.error && e.error.name) {
            if (e.error.name === "CubeError" || e.error.name === "ApiError") {
                _this.logError(e.error, e.error.data || {}, true);
                return;
            }

            _err = e.error;
        }

        ErrorHandler.logError(_err, e.filename, e.lineno, e.colno);
    });
};

App.prototype.init = function (args) {

    if (typeof args['settings'] == 'undefined') {
        throw new ErrorHandler.CubeError('Invalid settings');
    }

    if (typeof args['settings']['api_url'] == 'undefined') {
        throw new ErrorHandler.CubeError('Invalid Api Url');
    }

    this._api_url = $.trim(args['settings']['api_url'], '/');
};

App.prototype.logError = function(e, data, show_modal){

    show_modal = typeof show_modal == 'undefined' ? true : show_modal;

    if(typeof data != 'undefined' && $.isBoolean(data)) {
        show_modal = data;
        data = null;
    }

    $.loaderHide();
    ErrorHandler.logError(e, data);

    if(show_modal) {
        this.actions.showInfo(this,{
            content: Lang.error_please_reload_page
        });
    }

    console.error( e.name === "CubeError" || e.name === "ApiError" ? e.message : e );

};

App.prototype.getApiUrl = function () {
    if( this._api_url === undefined ) {
        throw new ErrorHandler.CubeError('Undefined Api URL.');
    }

    return this._api_url;
};

/**
 * Return session id (24 symbols)
 * @returns {string, null}
 */
App.prototype.getSessionId = function() {
    if(this._session_id === undefined) {
        // throw new ErrorHandler.CubeError('Undefined SessionId.');
        // this.logError( new ErrorHandler.CubeError('Undefined SessionId.'), false );
        console.warn("Undefined SessionID");
        return null;
    }

    return this._session_id.toString();
};

/**
 * Set private session id
 * @param id
 */
App.prototype.setSessionId = function( id ) {
    this._session_id = id.toString();
};

/**
 * Return unix timestamp
 * @returns {number}
 */
App.prototype.getTimestamp = function() {
    return Math.floor( new Date().getTime() / 1000 );
};

/**
 * Return random hex string
 * @param count
 * @returns {string}
 */
App.prototype.getRandomHex = function (count) {
  var result = "";
  var possible = "ABCDEF0123456789";

  for (var i = 0; i < count; i++)
    result += possible.charAt(Math.floor(Math.random() * possible.length));

  return result;
};

App.prototype.replaceUrlState = function () {
    window.history.replaceState({}, document.title, window.location.href.split(/[?#]/)[0]);

    return this;
};

App.prototype.sendApi = function (args) {

    var _this = this;
    $.loaderShow();

    var action = "showModal";
    var settings = {
            url: args.url,
            cache: args.cache || false,
            data: args.data || {},
            type: args.type || "GET",
            dataType: args.dataType || 'json',

            error: typeof args.error === 'function' ? args.error() : function (jqXHR) {
                $.loaderHide();
                throw new ErrorHandler.ApiError('AjaxError [002-02]. ' + jqXHR.responseText);
            },

            success: (typeof args.success === 'undefined') ? function (response) {

                if(typeof args['beforeSuccess'] === 'function') {
                    args['beforeSuccess'](response);
                }

                if (response['errCode'] == undefined || response['errCode'] != 0) {
                    throw new ErrorHandler.ApiError('[010.01] API response error.', response);
                }

                if (response['data'] == undefined) {
                    throw new ErrorHandler.ApiError('[010.02] API response error.', response);
                }

                if (response.data.session_id !== undefined) {
                    _this.setSessionId(response.data.session_id.toString());
                }

                if (response.data.action !== undefined) {
                    action = response.data.action.toString();
                }

                if (action.length > 0 && action in _this.actions) {
                    _this.actions[action]( _this, response.data );

                } else {
                    throw new ErrorHandler.ApiError('[010.03] API response error.', response);
                }

                if(typeof args.afterSuccess == 'function') {
                    args.afterSuccess(response);
                }

            } : args.success,

            complete: function () {
                $.loaderHide();
            }
        };

    if(args.data instanceof FormData) {
        settings.processData = false;
        settings.contentType = false;
    }

    try {
        $.ajax(settings);

    } catch (e) {
        throw e;
    }
};

App.prototype.consoleFormData = function (formData) {

    // for (var pair of formData.entries()) {
    // 	console.log(pair[0]+ ', ' + pair[1]);
    // }

    // for( of ) babel refactoring
    var _iteratorNormalCompletion = true;
    for (var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var pair = _step.value;
        console.log(pair[0] + ', ' + pair[1]);
    }
};

App.prototype.serializeWindowInfo = function(formData) {

    formData = formData || new FormData();
    var winfo = this.windowInfo();

    for (var prop in winfo) {
        // metaData[contact-city][value]
        formData.append('metaData[' + prop + '][label]', prop);
        formData.append('metaData[' + prop + '][type]', 'text');
        formData.append('metaData[' + prop + '][value]', winfo[prop]);
    }

    return formData;
};

App.prototype.serializeForm = function(form, formData) {

    formData = formData || new FormData();
    var skip = [];

    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];
        var value;
        var label = $("label[for='" + field.id + "']").text() || field.name;

        if (!field.name || $.isInArray(field.name, skip) || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        switch(field.type) {

            case 'select-one':
                value = field.options[field.selectedIndex].text;
                break;

            case 'select-multiple':
            // 	for (var n = 0; n < field.options.length; n++) {
            // 		if (!field.options[n].selected) continue;
            // 		serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
            // 	}
                break;

            case 'radio':
            case 'checkbox':
                // var name = field.name.replace('[]', '');
                var boxes = $("input[name^='" + field.name + "']");
                value = [];
                $.each(boxes, function() {
                    if(this.checked) {
                        value.push($("label[for='" + this.id + "']").text());
                    }
                });

                skip.push(field.name);

                break;

            case 'file':
                value = field.files[0];
                break;

            default:
                value = field.value;
                break;
        }

        formData.append('metaData['+field.name+'][type]', field.type);
        formData.append('metaData['+field.name+'][label]', label);
        formData.append('metaData['+field.name+'][value]', value);

    }
    return formData;
};

App.prototype.windowInfo = function() {
    return {
        'userAgent': navigator.userAgent,
        'screenSize': window.screen.availWidth + ' x ' + window.screen.availHeight,
        'location': window.location.href,
        'cookieEnabled': navigator.cookieEnabled,
        'language': navigator.language,
        'platform': navigator.platform,
        'appCodeName': navigator.appCodeName,
        'appName': navigator.appName
    }
};

App.prototype.actions = {

    showInfo: function ( instance, arg ) {
        this.showModal( instance, arg );
    },

    doShowError: function ( instance, arg ) {
        this.showModal( instance, arg );
    },

    showModal: function ( instance, arg ) {
        $( $.createModal(arg) ).remodal().open();
    },

    doBuildForm: function ( instance, data ) {
        var _modal = $.createModal({
            content: '<form method="post" enctype="multipart/form-data"></form>',
            title: 'Registration',
            subtitle: data['TitleFull'] || '',
            simple: false
        });

        document.body.appendChild(_modal);

        $(_modal).find('form')
            .formRender(data['Token'], data['RegistrationForm'])
            .maskFields()
            .labelAnim()
            .validate({
                rules: {
                    "contact-email": {
                        email: true
                    },
                    "contact-phone": {
                        phoneUA: true
                    }
                }
            })
            .appendRules();

        $(_modal).remodal().open();
    },

    submitForm: function ( instance, arg ) {
        $(icrm_liqpay_form).html(arg.content);
        $(icrm_liqpay_form + ' form').submit();
    },

    getForm: function( instance, arg ){
        instance.sendApi({
            url: instance.getApiUrl() + '/registration/getForm',
            data: { token: arg.token }
        });
    },

    getPayForm: function( instance, arg ){
        instance.setSessionId(arg.session_id);

        instance.sendApi({
            url: instance.getApiUrl() + "/payments/getForm",
            data: { session_id: arg.session_id },
            afterSuccess: function(){
                instance.replaceUrlState();
            }
        });
    },

    checkPayment: function( instance, arg ){
        if(typeof arg !== 'object' || !('session_id' in arg)){
            throw new ErrorHandler.ApiError('[100-04] Error for check payment request.');
        }

        instance.sendApi({
            url: instance.getApiUrl() + '/liqpay/checkPayment',
            data: {session_id: arg['session_id']},
            afterSuccess: function(){
                instance.replaceUrlState();
            }
        });
    },

    contactConfirm: function( instance, arg ){
        if(typeof arg !== 'object' || !('confirm_id' in arg) || !('session_id' in arg)){
            throw new ErrorHandler.CubeError('[100-03] Error for confirm contact.');
        }

        instance.setSessionId(arg.sessionId);

        instance.sendApi({
            url: instance.getApiUrl() + "/contacts/confirm",
            data: {
                confirm_id: arg.confirm_id,
                session_id: arg.session_id
            },
            afterSuccess: function(){
                instance.replaceUrlState();
            }
        });
    }
};

module.exports = new App();